import { HttpInterceptorFn } from '@angular/common/http';
import { from, switchMap } from 'rxjs';
import { authService } from './auth.service';
import { AppConfig } from '../config/app-config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Only attach token to requests going to our own API
  if (!req.url.startsWith(AppConfig.apiBaseUrl)) {
    return next(req);
  }

  // Skip if the user is not authenticated (e.g. guest or unauthenticated)
  if (!authService.isAuthenticated()) {
    return next(req);
  }

  return from(authService.getAccessToken()).pipe(
    switchMap(token => {
      const authed = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
      return next(authed);
    }),
  );
};
